export const MENTION_REGEX = /@([a-zA-Z0-9_.-]{2,32})/g;
export const MENTION_TOKEN_REGEX = /@([a-zA-Z0-9_.-]{2,32})/g;

export const idsMatch = (a, b) =>
  a != null && b != null && String(a) === String(b);

export const normalizeMentionUser = (user) => {
  if (!user || typeof user !== "object") return null;
  const nested = user.user && typeof user.user === "object" ? user.user : null;
  const _id =
    user._id ||
    user.id ||
    user.userId ||
    nested?._id ||
    nested?.id;
  const userName =
    user.userName ||
    user.username ||
    nested?.userName ||
    nested?.username;
  if (!_id || !userName) return null;
  return {
    _id,
    userName,
    avatarUrl:
      user.avatarUrl ||
      user.profile_pic ||
      user.imageUrl ||
      nested?.avatarUrl ||
      nested?.profile_pic ||
      "",
    isVip: user.isVip === true || user.isVip === "true" || nested?.isVip === true,
  };
};

export const collectChatUsers = ({
  messages = [],
  extraUsers = [],
  currentUserId,
} = {}) => {
  const map = new Map();

  const add = (user) => {
    const normalized = normalizeMentionUser(user);
    if (!normalized) return;
    if (currentUserId && idsMatch(normalized._id, currentUserId)) return;
    const key = String(normalized._id);
    if (!map.has(key)) map.set(key, normalized);
  };

  extraUsers.forEach(add);
  messages.forEach((msg) => {
    if (msg?.msgByUserId && typeof msg.msgByUserId === "object") {
      add(msg.msgByUserId);
    }
    if (msg?.sender && typeof msg.sender === "object") add(msg.sender);
    if (msg?.admin && typeof msg.admin === "object") add(msg.admin);
    if (msg?.replyTo?.msgByUserId && typeof msg.replyTo.msgByUserId === "object") {
      add(msg.replyTo.msgByUserId);
    }
    if (msg?.replyTo?.sender && typeof msg.replyTo.sender === "object") {
      add(msg.replyTo.sender);
    }
    if (Array.isArray(msg?.reactions)) {
      msg.reactions.forEach((reaction) => add(reaction));
    }
  });

  return Array.from(map.values()).sort((a, b) =>
    a.userName.localeCompare(b.userName)
  );
};

export const getActiveMention = (text = "", caret = 0) => {
  const before = text.slice(0, caret);
  const match = before.match(/(^|[\s])@([a-zA-Z0-9_.-]{0,32})$/);
  if (!match) return null;
  return {
    query: match[2] || "",
    start: caret - (match[2] || "").length - 1,
    end: caret,
  };
};

export const MENTION_DROPDOWN_LIMIT = 40;

export const filterMentionUsers = (users = [], query = "") => {
  const q = String(query).toLowerCase();
  const filtered = q
    ? users.filter((user) =>
      String(user.userName || "")
        .toLowerCase()
        .includes(q)
    )
    : users;

  const startsWith = [];
  const contains = [];
  filtered.forEach((user) => {
    if (!q) {
      contains.push(user);
      return;
    }
    if (String(user.userName || "").toLowerCase().startsWith(q)) {
      startsWith.push(user);
    } else {
      contains.push(user);
    }
  });

  return [...startsWith, ...contains].slice(0, MENTION_DROPDOWN_LIMIT);
};

export const mergeMentionUsers = (...lists) => {
  const map = new Map();
  lists.flat().forEach((user) => {
    const normalized = normalizeMentionUser(user);
    if (!normalized) return;
    const key = String(normalized._id);
    if (!map.has(key)) map.set(key, normalized);
  });
  return Array.from(map.values());
};

export const insertMention = (text = "", mention, userName) => {
  if (!mention) return text;
  const before = text.slice(0, mention.start);
  const after = text.slice(mention.end);
  const insertion = `@${userName} `;
  return {
    text: `${before}${insertion}${after}`,
    caret: before.length + insertion.length,
  };
};

export const isCurrentUserMentioned = (msg, userId) => {
  if (!userId || !Array.isArray(msg?.mentions) || !msg.mentions.length) {
    return false;
  }
  return msg.mentions.some((entry) => {
    if (entry == null) return false;
    if (typeof entry === "object") {
      return idsMatch(entry._id || entry.userId || entry.id, userId);
    }
    return idsMatch(entry, userId);
  });
};

export const findMentionUserId = (users = [], userName) => {
  const key = String(userName || "").trim().toLowerCase();
  if (!key) return null;
  const match = users.find((user) => {
    const name = user?.userName || user?.username;
    return name && String(name).trim().toLowerCase() === key;
  });
  return match?._id || match?.id || match?.userId || null;
};

export const mentionedRowClass = (msg, userId) =>
  isCurrentUserMentioned(msg, userId) ? " is-mentioned" : "";
